<template>
    <columns property="addresses" v-on:add="openForm">
        <column-item
            v-bind:update="{updatedBy: item.updatedBy, updatedAt: item.updatedAt}"
            slot-scope="{item}"
            :api="'/api/addresses/' + item.id"
            v-bind:label="label(item)"
            v-on:edit="openForm(item)"
            v-on:delete="deleteItem('addresses', item)"
            class="has-merge-status"
        >
            <span v-if="showMergeStatus" class="merge-status is-corner" :class="mergeStatusClass(item.mergeStatus)" :title="mergeStatusLabel(item.mergeStatus)">{{ mergeStatusShort(item.mergeStatus) }}</span>
            <ul>
                <li v-if="item.title"><strong>{{item.title}}</strong></li>
                <li v-if="item.streetAddress">{{item.streetAddress}}</li>
                <li v-if="item.zip">{{item.zip}} {{item.city}}</li>
                <li v-if="item.country">{{country(item)}}</li>

                <li v-if="item.port">
                    <a v-bind:href="`/ports/${item.port.id}`" target="_blank">
                        <i class="material-icons">directions_boat</i>
                    {{item.port.place.name}}
                    </a>
                </li>

                <li v-if="item.airport">
                    <a v-bind:href="`/airport/${item.airport.id}`" target="_blank">
                        <i class="material-icons">airplanemode_active</i>
                        {{item.airport.name}}
                    </a>
                </li>
            </ul>

            <a v-bind:href="googleMapsLink(item)" target="_blank" slot="actions">
                <i class="material-icons">location_on</i>Maps
            </a>

        </column-item>

        <address-form ref="form" slot="form" />
    </columns>
</template>

<script>
import Mixin from '../tab';
import AddressForm from './Form';
import { settings } from '@clientSpecific/utilities/settings';
import { getAxios } from '@api';

export default {
    mixins: [ Mixin ],

    components: {AddressForm},

    computed: {
        types: function () {return this.options.addresses ? this.options.addresses.type : [] },
        showMergeStatus: function () {
            return settings.crud.mergeStatus;
        },
        api: function () {
            return this.$store.state.api;
        },
        getFilter () {
            if (['hotels', 'ferries', 'others', 'trains', 'airlines'].includes(this.api)) {
                return {'provider.id': this.item.id};
            } else if (this.api === 'agencies') {
                return {'agency.id': this.item.id};
            } else if (this.api === 'clients') {
                return {'clients.id': this.item.id};
            } else if (this.api === 'ports') {
                return {'port.id': this.item.id};
            } else if (this.api === 'airports') {
                return {'airport.id': this.item.id};
            }
            return {};
        }
    },
    methods: {
        label: function (item) {
            if(!item) {
                return '';
            }
            const type = this.types.find(t => t.key === item.type)
            return !!type ? type.value : "";
        },
        openForm: function (data = {}) {
            this.$refs.form.open({
                title: this.item.name ? this.item.name : this.item.companyName,
                ...data
            });
        },
        mergeStatusLabel: function (status) {
            switch (status) {
                case 'welcome': return 'Welcome Tours';
                case 'buspaket': return 'Buspaket';
                case 'merged':
                case null:
                case undefined:
                    return 'Zusammengeführt';
                default: return status;
            }
        },
        mergeStatusShort: function (status) {
            switch (status) {
                case 'welcome': return 'W';
                case 'buspaket': return 'B';
                case 'merged':
                case null:
                case undefined:
                    return '';
                default: return '-';
            }
        },
        mergeStatusClass: function (status) {
            switch (status) {
                case 'welcome': return 'is-welcome';
                case 'buspaket': return 'is-buspaket';
                case 'merged':
                case null:
                case undefined:
                    return 'is-merged';
                default: return '';
            }
        },
    },
    mounted() {
        this.label();
        if (this.showMergeStatus) {
            this.$store.state.data.addresses = [];
            getAxios('addresses', {_groups: ['address_read', 'merge_status'], ...this.getFilter}).then(response => {
                this.$store.state.data.addresses = response.data;
            });
        }
    }
}
</script>
